import { motion } from "framer-motion";
import Seo from "../components/Seo";
import ResourcesSection from "../components/ResourcesSection";
import { BOOK_DEMO_URL } from "../lib/constants";

export default function Resources() {
  return (
    <main className="flex-grow">
      <Seo
        title="Resources & Downloads"
        description="Flyers and coverage documents for Attack Surface Intelligence, Digital Risk Intelligence, and Compliance & Cloud Security — download the PDF for each CyberMon product."
        path="/resources"
      />

      <section className="relative pt-16 md:pt-section-gap pb-16 px-margin-mobile md:px-gutter max-w-container-max mx-auto overflow-hidden">
        <div className="absolute inset-0 bg-glow-orange opacity-50 pointer-events-none" />
        <div className="relative z-10 text-center max-w-3xl mx-auto">
          <p className="font-eyebrow text-eyebrow text-primary mb-stack-md uppercase tracking-widest">
            Resources
          </p>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="font-display-hero-mobile text-display-hero-mobile md:font-display-hero md:text-display-hero text-on-surface dark:text-surface-bright mb-stack-lg"
          >
            Resources &amp; Downloads
          </motion.h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant dark:text-surface-variant max-w-2xl mx-auto">
            One flyer and one coverage document per product, plus the full platform picture.
            No form to fill in — download what you need.
          </p>
        </div>
      </section>

      <ResourcesSection
        moduleKey="platform"
        contained
        eyebrow="Start Here"
        eyebrowColor="text-on-surface dark:text-surface-bright"
        heading="The CyberMon Platform"
        subhead="All three products in one document — the correlation argument, the unified risk score, and how CyberMon compares against the alternatives."
      />

      <ResourcesSection
        moduleKey="asm"
        contained
        eyebrow="Module 1"
        eyebrowColor="text-primary"
        heading="Attack Surface Intelligence"
        subhead="Every domain, IP, API, cloud resource and AI endpoint you own — discovered, scored and monitored continuously, including exposed logins without MFA."
      />

      <ResourcesSection
        moduleKey="dri"
        contained
        eyebrow="Module 2"
        eyebrowColor="text-secondary"
        heading="Digital Risk Intelligence"
        subhead="What is being said, sold and faked about you outside the firewall — across eight monitored source classes."
      />

      <ResourcesSection
        moduleKey="compliance"
        contained
        eyebrow="Module 3"
        eyebrowColor="text-on-surface dark:text-surface-bright"
        heading="Compliance & Cloud Security"
        subhead="Continuous checks mapped to SOC 2, ISO 27001, GDPR and PCI DSS, with evidence attached to every finding."
      />

      <section className="text-center py-section-gap px-gutter">
        <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright mb-stack-lg">
          Want to see it running on your own domain?
        </h2>
        <a
          href={BOOK_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center bg-primary-container text-on-primary-container font-headline-card px-8 py-4 rounded-DEFAULT hover:scale-105 transition-transform shadow-sm font-semibold"
        >
          Book a Demo
        </a>
      </section>
    </main>
  );
}
